import catalog from 'apis/catalog';

import type { RawSVGAPIData } from './svgs.types';

export const get = async (id: string) => {
  const { data } = await catalog.get<RawSVGAPIData>(`/svg_images/uid/${id}.json`);
  return data;
};
